var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"0","color":"grey lighten-4"}},[_c('v-card-text',[_c('div',{staticClass:"subtitle-1 text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"headline text-center"},[_vm._v(" "+_vm._s(_vm.fact)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }